/**
 * Normalizes a pasted map link into a safe http(s) URL for <a href>, or '' if invalid.
 */
export function mapLinkHref(raw) {
  const t = String(raw || '').trim();
  if (!t) return '';
  const candidate = /^https?:\/\//i.test(t) ? t : `https://${t.replace(/^\/\//, '').replace(/^\/+/, '')}`;
  try {
    const u = new URL(candidate);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return '';
    return u.href;
  } catch {
    return '';
  }
}
